import Head from 'next/head';
import { Header, Footer, Plain } from '@components';
import { Box, Flex } from '@chakra-ui/react';

export function FaqPage() {
  return (
    <Flex direction={'column'} minH={'100vh'}>
      <Head>
        <title>FAQ | IKSEL Studio Reklamy - Reklama dla Twojej firmy</title>

        <meta
          name="description"
          content="IKSEL Studio Reklamy - FAQ - Przykłady najczęściej zadawanych pytań i odpowiedzi. Kompleksowa obsługa reklamowa i kampanie marketingowe"
        />
      </Head>

      <Header
        id="header"
        logo={{
          imageUrl: '/images/logo_medium.png',
          href: '/',
        }}
        menu={{
          elements: [
            {
              id: 'header-strona-glowna-link',
              label: 'Strona główna',
              href: '/',
            },
            {
              id: 'header-oferta-link',
              label: 'Oferta',
              href: '/#oferta',
            },
            {
              id: 'header-aktualnosci-link',
              label: 'Aktualności',
              href: 'https://www.facebook.com/IKSEL.reklama',
            },
            {
              id: 'header-kontakt-link',
              label: 'Kontakt',
              href: '/kontakt',
            },
          ],
        }}
      />

      <Box flex={1}>
        <Plain
          id="faq"
          title="Najczęściej zadawane pytania"
          subtitle="Być może znajdziesz tu odpowiedź na swoje pytanie"
          html={`
            <h3>Czym r&oacute;żni się IKSEL Advertising od innych drukarni ?</h3>
            <p><strong>IKSEL</strong>&nbsp;jest Drukarnią internetową - oznacza to, że produkty dostępne w sklepie można zam&oacute;wić korzystając ze strony www.iksel.com.pl bądź drogą e-mailową zgodnie z otrzymaną ofertą.</p>
          
            <Kurier>Na stronie gł&oacute;wnej należy wybrać interesujący produkt i wysłać zapytanie. Informacje o etapie zam&oacute;wienia( terminie realizacji, płatności, i inne ) będą przesyłane na podany przez Państwa adres e-mail. Kurier dostarczy paczkę.</p>
          
            <ul>
            <li>Zam&oacute;wienia można składać przez cały czas, 24 godziny 7 dni w tygodniu.</li>
            <li>Gwarantujemy kr&oacute;tkie terminy realizacji.</li>
            <li>Zapewniamy najwyższą jakość.</li>
            <li>Drukujemy na nowoczesnych maszynach wyposażonych w systemy kontrolujące.</li>
            <li>Każda praca drukowana jest w technice offsetowej z wykorzystaniem technologii CTP.</li>
            <li>Używamy wysokiej jakości papier&oacute;w do druku.</li>
            <li>Nowoczesny system informatyczny zapewnia klientom profesjonalną obsługę oraz zawsze aktualne informacje.</li>
            <li>Gwarantujemy niską cenę: robimy wszystko, aby cena była atrakcyjna.</li>
            </ul>
            <h3>Czy mogę anulować zlecenie ?</h3>
            <p>Zam&oacute;wienie można usunąć tylko przed dokonaniem płatności. Po otrzymaniu płatności produkt zlecany jest niezwłocznie do druku aby przyspieszyć termin realizacji.</p>
            <h3>Czy mogę zam&oacute;wić produkt, kt&oacute;rego nie ma w asortymencie?</h3>
            <p>Drukarnia IKSEL Advertising realizuje zam&oacute;wienia zgodnie z asortymentem podanym na stronie. Zam&oacute;wienia, kt&oacute;rych nie ma w asortymencie Drukarni IKSEL Advertising, można realizować poza sklepem przez naszych handlowc&oacute;w. Można tego dokonać uprzednio wysyłając zapytanie ofertowe. Aby przejść do strony kontaktowej, kliknij&nbsp;<a href="http://iksel.com.pl/kontakt">tutaj</a></p>
            <h3>Dlaczego moje zam&oacute;wienie zostało odrzucone?</h3>
            <p>Zlecenia w firmie IKSEL Advertising są odrzucane z kliku powod&oacute;w:</p>
            <ul>
            <li>niezgodność pliku ze specyfikacją druku Drukarni IKSEL,</li>
            <li>niezgodność pliku z danym zleceniem np. zlecenie jest na ulotkę A5 a plik to plakat B1 lub zam&oacute;wienie jest na katalog 16 stron a w pliku jest tylko 14 stron.</li>
            </ul>
            <p><strong>Uwaga!</strong>&nbsp;Przypominamy, że czas realizacji zlecenia jest liczony od momentu otrzymania akceptacji danego pliku.</p>
            <h3>W jaki spos&oacute;b mogę uzyskać informacje na temat wyceny produkt&oacute;w, kt&oacute;rych nie ma w asortymencie drukarni IKSEL Advertising?</h3>
            <p>Wszelkie zapytania dotyczące wyceny produkt&oacute;w, należy wysyłać mailowo -&nbsp;<a href="http://iksel.com.pl/kontakt">przejdź do strony kontaktowej</a></p>
            
            <h3>Jaki jest czas oczekiwania na odpowiedź na zapytanie ofertowe wysłane na e-maill?</h3>
            <p>Czas odpowiedzi zazwyczaj nie przekracza 1 godziny.</p>
            <h3>Czy wystarczy tylko zakupić dany produkt w sklepie i czekać na realizację zam&oacute;wienia?</h3>
            <p>Nie, po złożeniu zam&oacute;wienia w drukarnii IKSEL należy opłacić przesłaną fakturę pro-forma i przesłać do nas potwierdzenie przelewu (w celu przyspieszenia procedury) następnie zostaniesz poproszony o przesłanie projektu do druku w celu weryfikacji. Jeśli plik przejdzie weryfikację zostaniesz od razu o tym poinformowany i zam&oacute;wienie zostanie przekazane do realizacji. O wszystkich etapach zam&oacute;wienia będziesz informowany mailowo.</p>
          
            <p>Drugą możliwością jest zlecenie projektu naszej drukarni. W tym celu proszę o przesłanie takiego zapytania do obsługi naszego sklepu. Zostaniesz dalej poinstruowany jak postępować. Czas realizacji zam&oacute;wienia liczony jest od momentu akceptacji projektu przez klienta.</p>`}
        />
      </Box>

      <Footer
        id="footer"
        logo={{
          imageUrl: '/images/logo_medium.png',
          href: '/',
        }}
        categories={[
          {
            name: 'Zasady',
            elements: [
              {
                text: 'Polityka prywatności',
                href: '/polityka-prywatnosci',
              },
              {
                text: 'Płatność i dostawa',
                href: '/platnosc-i-dostawa',
              },
              {
                text: 'FAQ',
                href: '/faq',
              },
            ],
          },
          {
            name: 'Pomoc',
            elements: [
              {
                text: 'Jak zamawiać?',
                href: '/jak-zamawiac',
              },
              {
                text: 'Akceptowalne pliki',
                href: '/akceptowalne-pliki',
              },
              {
                text: 'Projektowanie',
                href: '/projektowanie',
              },
            ],
          },
        ]}
      />
    </Flex>
  );
}

export default FaqPage;
